import React from "react";
import { hydrate, render } from "react-dom";
import { combineReducers, compose, createStore, applyMiddleware } from "redux";
import {
  routerForBrowser,
  initializeCurrentLocation,
} from "redux-little-router";
import { Provider } from "react-redux";
import thunk from "redux-thunk";

import "./index.scss";
import App from "./App";
// import registerServiceWorker from './registerServiceWorker';

import routes from "./routes";
import breadcrumbReducer from "./state/Breadcrumbs/reducers/breadcrumbReducer";
import { logEndpoint, routerBase, env, buildNumber } from "./config";
import { handleLocationChange } from "./middleware";

// Set up error logs endpoint
window.Raven &&
  window.Raven.config(logEndpoint, {
    environment: env,
    release: buildNumber || "latest",
  }).install();

// Set up routes middleware
const { reducer: routerReducer, middleware, enhancer } = routerForBrowser({
  // The configured routes. Required.
  routes,
  basename: routerBase,
});

// Set up and configure store
const store = createStore(
  combineReducers({
    router: routerReducer,
    breadcrumbs: breadcrumbReducer,
  }),
  compose(
    enhancer,
    applyMiddleware(handleLocationChange),
    applyMiddleware(middleware),
    applyMiddleware(thunk)
  )
);

// ...after creating store
const initialLocation = store.getState().router;
if (initialLocation) {
  store.dispatch(initializeCurrentLocation(initialLocation));
}

// RENDER APPLICATION
const root = document.getElementById("root");

const Main = (
  <Provider store={store}>
    <App />
  </Provider>
);

if (root.hasChildNodes()) {
  hydrate(Main, root);
} else {
  render(Main, root);
}



// WEBPACK FOOTER //
// ./src/index.js